import { Switch } from '@thanx/uikit/switch'
import useFlag from 'hooks/useFlag'
import { buildTranslate } from 'locales'
import { getAdminSegmentUrl } from 'utilities/urlUtils'

const t = buildTranslate('components.ai.segment_visualization')

interface SegmentCampaignActionsProps {
  onCreateCampaignClick: () => void
  onViewSegmentClick: () => void
  isLoading?: boolean
  savedSegmentId?: number
  isLatestSavedSegment?: boolean
}

const SegmentCampaignActions = ({
  onCreateCampaignClick,
  onViewSegmentClick,
  isLoading = false,
  savedSegmentId,
  isLatestSavedSegment = false,
}: SegmentCampaignActionsProps) => {
  const aiSegmentDevtoolsEnabled = useFlag('ai-segment-devtools-enabled', false)

  const handleViewInAdmin = () => {
    if (!savedSegmentId) return

    const adminUrl = getAdminSegmentUrl(savedSegmentId)
    window.open(adminUrl, '_blank', 'noopener,noreferrer')
  }

  return (
    <div className="thanx-ai-segment-visualization__actions">
      <Switch condition={aiSegmentDevtoolsEnabled && !!savedSegmentId}>
        <button
          className="thanx-ai-segment-visualization__action-btn thanx-ai-segment-visualization__action-btn--secondary"
          onClick={handleViewInAdmin}
          disabled={isLoading}
        >
          {t('view_in_admin')}
        </button>
      </Switch>
      <Switch condition={isLatestSavedSegment}>
        <button
          className="thanx-ai-segment-visualization__action-btn thanx-ai-segment-visualization__action-btn--secondary"
          onClick={onViewSegmentClick}
          disabled={isLoading || !savedSegmentId}
        >
          {t('view_segment')}
        </button>
      </Switch>
      <button
        className="thanx-ai-segment-visualization__action-btn thanx-ai-segment-visualization__action-btn--primary"
        onClick={onCreateCampaignClick}
        disabled={isLoading}
      >
        {isLoading ? t('loading') : t('create_campaign')}
      </button>
    </div>
  )
}

export default SegmentCampaignActions
